module.exports = __webpack_public_path__ + "static/media/landing_background.563bdd26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pictures/landing_background.jpg
// module id = 30
// module chunks = 0